import {Form} from '@esgi/ui/form';
import {styled} from '@esgi/ui/theme';
import {contentRowGap} from './body';

export const FormRoot = styled(Form, {
	display: 'grid',
	rowGap: contentRowGap,
});
